import { observable } from 'mobx';
import { observer } from 'mobx-react';
import {
  DefaultButton,
  PrimaryButton,
} from 'office-ui-fabric-react/lib/Button';
import {
  Dialog,
  DialogFooter,
  DialogType,
} from 'office-ui-fabric-react/lib/Dialog';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { localizable } from '../../../components/Localization';
import React, { Component } from 'react';

@localizable
@observer
export default class BlockDialog extends Component {
  @observable reason = '';

  handleChange = (e) => {
    this.reason = e.target.value;
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    if (onSubmit) {
      onSubmit(this.reason);
    }
  };

  handleClose = () => {
    const { onClose } = this.props;
    if (onClose) {
      onClose();
      this.reason = '';
    }
  };

  render() {
    const { onClose, t } = this.props;

    return (
      <Dialog
        minWidth={600}
        hidden={false}
        onDismiss={onClose}
        dialogContentProps={{
          type: DialogType.largeHeader,
          title: t('Block Agent'),
        }}
        modalProps={{
          isBlocking: true,
          containerClassName: 'ms-dialogMainOverride',
        }}
      >
        <div className="ms-Grid">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-lg12 ms-md12 ms-sm12">
              <TextField
                label={t('Reason')}
                multiline
                name="reason"
                value={this.reason}
                onChange={this.handleChange}
              />
            </div>
          </div>
        </div>

        <DialogFooter>
          <PrimaryButton onClick={this.handleSubmit} text={t('Block')} />
          <DefaultButton onClick={onClose} text={t('Cancel')} />
        </DialogFooter>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/WhitelistingSection/BlockDialog.jsx